module.exports = __webpack_public_path__ + "static/media/me.3a6303f2.png";